import { Component, Output, EventEmitter, Input, ViewChild } from '@angular/core';

import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-revoke-text-message-consent-modal',
    templateUrl: './revoke-text-message-consent-modal.component.html',
    styleUrls: ['./revoke-text-message-consent-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class RevokeTextMessageConsentComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;

  @Output() revoked = new EventEmitter();
  @Output() canceled = new EventEmitter();

  @Input() modalId = 'revoke-text-message-consent-modal';

  show() {
    this.modal.show();
  }

  cancel() {
    this.canceled.emit();
    this.close();
  }

  revoke() {
    this.revoked.emit();
    this.close();
  }

  close() {
    this.modal.close();
  }
}
